import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';
import * as types from './types';
import { UserState } from '../../types';
import { setItem } from '../../services/localStorageService';
import { LOCAL_STORAGE_KEYS } from '../../consts/constants';

type UserAction = { type: string; payload: UserState };

const initialState: UserState | null = null;

const userReducer = (
  state: UserState | null,
  action: UserAction,
): UserState | null => {
  switch (action.type) {
    case types.SET_USER_INFO:
      setItem(LOCAL_STORAGE_KEYS.USER_TYPE, action.payload.userType);
      setItem(LOCAL_STORAGE_KEYS.USER_ID, action.payload.id);
      return {
        ...state,
        ...action.payload,
      };
    default:
      return initialState;
  }
};

type UserContextType = [UserState | null, Dispatch<UserAction>];
export const UserContext = createContext<UserContextType>([
  initialState,
  () => initialState,
]);

const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userInfo, dispatchUserInfo] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={[userInfo, dispatchUserInfo]}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
